import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.small};
`;

export const MessageEditorWrapper = styled.div`
  position: sticky;
  top: 0;
  background: ${colors.white};
`;
